import './styles.less';

import 'expose-loader?$!expose-loader?jQuery!jquery';
import 'expose-loader?_!underscore';
import 'expose-loader?angular!angular';

import 'angular-animate';
import 'angular-cookies';
import 'angular-resource';
import 'angular-route';
import 'angular-sanitize';
import 'angular-touch';

import '@uirouter/angularjs';
// import 'ng-table';
import 'angular-file-upload';
import 'angular-moment';
import 'angular-spinner';
import 'angular-ui-bootstrap';
import 'angular-ui-sortable';
import 'angular-xeditable';
import 'expose-loader?moment!moment-timezone';
import 'malihu-custom-scrollbar-plugin';
import 'ngstorage';
import 'signalr';
import 'social-likes';

import '../assets/js/autosize.min.js';
import '../assets/js/clipboard.min.js';
import '../assets/js/homepage/jquery.prettyPhoto.js';
import '../assets/js/jquery.columnizer.js';
import '../assets/js/vendor/angular-ellipsis/angular-ellipsis.js';
import '../assets/js/vendor/angular-filter/angular-filter.js';
import '../assets/js/vendor/angular-flot/angular-flot.js';
import '../assets/js/vendor/angular-lightbox/angular-lightbox.js';
import '../assets/js/vendor/angular-loading-bar/loading-bar.js';
import '../assets/js/vendor/angular-tree-control/angular-tree-control.js';
import '../assets/js/vendor/angular-ui-map/ui-map.js';
import '../assets/js/vendor/angular-ui-select/select.js';
import '../assets/js/vendor/angular-ui-utils/ui-utils.js';
import '../assets/js/vendor/AngularJS-Toaster/toaster.js';
import '../assets/js/vendor/bootstrap-filestyle/bootstrap-filestyle.js';
import '../assets/js/vendor/jquery-ui/jquery-ui.js';
import '../assets/js/vendor/jquery.smartbanner/jquery.smartbanner.js';
import '../assets/js/vendor/jqueryui-touch-punch/jquery.ui.touch-punch.js';
import '../assets/js/vendor/mr-image/mr-image.js';
import '../assets/js/vendor/ng-table/ng-table.js';
import '../assets/js/vendor/rangy/rangy-classapplier.js';
import '../assets/js/vendor/rangy/rangy-core.js';
import '../assets/js/vendor/rangy/rangy-selectionsaverestore.js';
import '../assets/js/vendor/slimscroll/jquery.slimscroll.js';
import '../assets/js/vendor/spin.js/spin.js';
// textangular for wysiwygServise

import 'expose-loader?rangy!rangy';
import 'expose-loader?rangy.saveSelection!rangy/lib/rangy-selectionsaverestore';

// import 'textangular/dist/textAngular-sanitize';
import '../assets/js/vendor/textAngular/textAngular-sanitize.js';
import '../assets/js/vendor/textAngular/textAngular.js';
import '../assets/js/vendor/textAngular/textAngularSetup.js';

// import angular-ui-tree lib
import '../assets/js/angular-ui-tree.min.js';

const context = require.context('../assets/js/vendor/flot', true);
context.keys().forEach(context);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/vendor/index.ts